module.exports = __webpack_public_path__ + "static/img/52.f071526.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/52.png
// module id = ffqc
// module chunks = 0